<!-- Document Selection Dropdown -->
@if (hasDocuments) {
  <div class="form-group">
    <label class="form-label">This document is:</label>
    <mat-form-field appearance="outline" class="document-select full-width">
      <mat-select [(value)]="value" (selectionChange)="selectionChanged()" [class.mat-form-field-invalid]="!value">
      <mat-option disabled selected value="">
      Select a document or choose "Something Else.."
    </mat-option>
        @for (doc of documentSelection; track doc.id) {
          <mat-option [value]="doc">
            {{ doc.fileDesc }}
          </mat-option>
        }
        <mat-option value="other">Something Else..</mat-option>
      </mat-select>
       @if (hasDocuments && !value) {
        <mat-error>
          <span>Please select a document</span>
        </mat-error>
      }
    </mat-form-field>
  </div>
}

<!-- Document Description Input -->
@if (selectedDocumentId === 'other' || !hasDocuments || isMessageAttachment) {
  <div class="form-group">
    <label class="form-label">Please describe the document you are uploading. (Minimum length is 3, maximum length is 80):</label>
    <mat-form-field appearance="outline" class="full-width">
      <input 
        matInput
        #descriptionInput 
        name="description" 
        placeholder="Description"
        [(ngModel)]="docDescription" 
        (keyup)="descriptionKeyup()" 
        maxlength="80"
        [class.mat-form-field-invalid]="(selectedDocumentId === 'other' || !hasDocuments) && (docDescription?.length ?? 0) < 3">
      <mat-hint align="end">{{ docDescription?.length ?? 0 }}/80</mat-hint>
      @if ((selectedDocumentId === 'other' || !hasDocuments) && (docDescription?.length ?? 0) < 3) {
        <mat-error>
          <span>Description must be at least 3 characters</span>
        </mat-error>
      }
    </mat-form-field>
  </div>
}